import React from "react";
import "./Back.css";
import { message } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { ORGANIZED_TOURS, PACKAGES, useSearch } from "../../contexts/SearchContext";
import { getUserDetails } from "../../services/authService";
import {
  extractHotelIdFromProfilePathname,
  HOTEL_PROFILE_BACK_MISSING_CONTEXT_MESSAGE,
  isHotelProfilePathname,
  navigateHotelProfileBackToResults,
} from "../../features/hotelSearchResults/hotelSearchResultsNavigation";

const BackButton = ({ searchTab: searchTabProp = null }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { searchPhrase, searchTab: searchTabContext } = useSearch();
  const searchTab = searchTabProp ?? searchTabContext ?? null;

  const goBack = () => {
    if (isHotelProfilePathname(location.pathname)) {
      const isDynamicPackage =
        typeof location.pathname === "string" &&
        location.pathname.includes("/dynamic-package-profile/");
      const resolved = navigateHotelProfileBackToResults(navigate, location, {
        hotelId: extractHotelIdFromProfilePathname(location.pathname),
        searchPhrase,
        searchTab,
        isDynamicPackage,
      });
      if (!resolved?.canNavigate) {
        message.error(HOTEL_PROFILE_BACK_MISSING_CONTEXT_MESSAGE);
      }
      return;
    }

    const getSearchTab = () => {
      if (
        location.pathname.includes("/tour/profile") ||
        location.pathname.includes("/organized-tours/profile") ||
        location.pathname.includes("OrganizedTour") ||
        searchTab === ORGANIZED_TOURS
      ) {
        return ORGANIZED_TOURS;
      }
      if (
        location.pathname.includes("/packages/profile") ||
        location.pathname.includes("FlightsHotel") ||
        searchTab === PACKAGES
      ) {
        return PACKAGES;
      }
      return null;
    };

    const tabToSave = getSearchTab();
    if (tabToSave) {
      try {
        localStorage.setItem("searchTab", tabToSave);
      } catch (error) {
        if (process.env.NODE_ENV === "development") {
          console.error("[Back] Error saving searchTab:", error);
        }
      }
    }

    const isHotelProfile = location.pathname.includes("hotelprofile");
    const user = getUserDetails();
    const isAgentOrAdmin =
      user &&
      (user.usertype === "agents" ||
        user.usertype === "admins" ||
        user.userType === "agents" ||
        user.userType === "admins");
    const target =
      isHotelProfile && !isAgentOrAdmin ? "/flights/booking" : "/p/dashboard/searchoffer";
    navigate(target);
  };

  return (
    <button className="back-btn" type="button" onClick={goBack}>
      חזור לתוצאות החיפוש
    </button>
  );
};

export default BackButton;
